import { render, staticRenderFns } from "./ReportTableParks.vue?vue&type=template&id=64790ece"
import script from "./ReportTableParks.vue?vue&type=script&lang=ts"
export * from "./ReportTableParks.vue?vue&type=script&lang=ts"
import style0 from "./ReportTableParks.vue?vue&type=style&index=0&id=64790ece&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports